import { Box, Grid, Hidden, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import Developer from "./developer/developer";
import "./hero.scss";
import TextType from "../../common/bits/text-type";
// import { ReactComponent as Developer } from './Web_developer_Flatline.svg';

export default function Hero() {
  const theme = useTheme();
  const _mTypeTexts = ["Hello world !", "Hey there!", "Hi, I build digital things.", "Hey there Happy coding!"];
  // "Hi, I build digital things.", "Hey there Happy coding!";
  // const ltxs = useMediaQuery(theme.breakpoints.down("xs"));
  const ltsm = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" className={"main"}>
      {/* <Box display="flex" flexDirection={ltsm ? "column" : "row"} justifyContent="center"> */}
      <Grid
        container
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "100%", // 👶 Small screens → stack
            sm: "35% 60%", // 📱 Tablet & above → side by side
          },
          alignItems: "center",
          gap: 2,
        }}
      >
        <Hidden smDown>
          <Box
            sx={{
              flexShrink: 0,
              width: "100%", // full 40% area
            }}
          >
            <Developer></Developer>
          </Box>
        </Hidden>

        <Box
          sx={{
            minWidth: 0,
            overflowWrap: "break-word",
            wordBreak: "break-word",
          }}
        >
          <Box
            sx={{
              display: "inline-block",
              maxWidth: "100%",
              paddingLeft: {
                xs: 4,
                sm: 2,
              },
            }}
          >
            <p className="app-font--secondary ui-opacity--light ui-font-weight--bold app-font-size--half ui-nowrap">&lt;developer&gt;</p>
            <div className="ui-typo--h2 ui-font-weight--medium "></div>
            <h1 className="ui-typo--h2 ui-font-weight--medium ">
              <TextType text={_mTypeTexts} typingSpeed={75} pauseDuration={1500} showCursor={true} cursorCharacter="|" />
              <span className="ui-typo--h2  ui-font-weight--medium">{/* <span className="wobbler ui-display--inline-block">,</span> */}</span>
              <br /> I am a Full Stack <br /> Developer
            </h1>
            <p className="app-font--secondary ui-opacity--light ui-font-weight--bold app-font-size--half ui-nowrap">&lt;\developer&gt;</p>
          </Box>
        </Box>
      </Grid>
      {/* </Box> */}
    </Box>
  );
}
